// @unocss-include
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Slot } from '@radix-ui/react-slot';
import clsx from 'clsx';
import { useIsKeyboardOpen } from '../../hooks.js';
export const HideWhileKeyboardOpen = function HideWhileKeyboardOpen(_a) {
    var { ref, asChild, className } = _a, rest = __rest(_a, ["ref", "asChild", "className"]);
    const isKeyboardOpen = useIsKeyboardOpen();
    const Comp = asChild ? Slot : 'div';
    return (_jsx(Comp, Object.assign({ ref: ref, className: clsx(isKeyboardOpen && 'layer-responsive:hidden', className) }, rest)));
};
//# sourceMappingURL=HideWhileKeyboardOpen.js.map